import Reflux from "reflux";
export const LoggerActions = {
  get: Reflux.createAction()
};
